export const transactions = [
  {
    title: 'CliQ - Ahmad Zain',
    date: '15 Oct 2025',
    amount: -220.0,
    status: 'Pending approval',
  },
  {
    title: 'User management - Edit user details',
    date: '13 Oct 2025',
    status: 'Accepted',
    transactionType: 'edit-user-details'
  },
  {
    title: 'User management - Add new users',
    date: '08 Oct 2025',
    status: 'Rejected',
    transactionType: 'add-new-user'
  },
  {
    title: 'User management - Reactivate user',
    date: '05 Oct 2025',
    status: 'Pending approval',
    transactionType: 'reactivate-user'
  },
  {
    title: 'User management - Password reset',
    date: '01 Oct 2025',
    status: 'Accepted',
    transactionType: 'password-reset'
  },
  {
    title: 'User management - Suspend user',
    date: '15 Oct 2025',
    amount: -220.0,
    status: 'Pending approval',
    transactionType: 'suspend-user'
  },
  {
    title: 'User management- Edit role',
    date: '13 Oct 2025',
    amount: 120.650,
    status: 'Accepted',
    transactionType: 'edit-role'
  },
  {
    title: 'User management- Create role',
    date: '08 Oct 2025',
    status: 'Rejected',
    transactionType: 'create-role'
  },
  {
    title: 'User management- Delete role',
    date: '05 Oct 2025',
    status: 'Pending approval',
    transactionType: 'delete-role'
  },
  {
    title: 'Portal management - Add new user',
    date: '01 Oct 2025',
    status: 'Accepted',
  },
];

// countries.ts
export const countries = [
  { code: 'JO', icon: 'assets/icons/flags/jordan.svg', label: 'Jordan' },

  { code: 'KW', icon: 'assets/icons/flags/kuwait.svg', label: 'Kuwait' },
  { code: 'QA', icon: 'assets/icons/flags/qatar.svg', label: 'Qatar' },
  { code: 'SA', icon: 'assets/icons/flags/saudi-arabia.svg', label: 'Saudi Arabia' },
  { code: 'AE', icon: 'assets/icons/flags/united-arab-emirates.svg', label: 'United Arab Emirates' },
  { code: 'OM', icon: 'assets/icons/flags/oman.svg', label: 'Oman' },
  { code: 'BH', icon: 'assets/icons/flags/bahrain.svg', label: 'Bahrain' },
  { code: 'EG', icon: 'assets/icons/flags/egypt.svg', label: 'Egypt' },

  { code: 'JM', icon: 'assets/icons/flags/jamaica.svg', label: 'Jamaica' },
  { code: 'JE', icon: 'assets/icons/flags/jersey.svg', label: 'Jersey' },
  { code: 'JP', icon: 'assets/icons/flags/japan.svg', label: 'Japan' },
  { code: 'KE', icon: 'assets/icons/flags/kenya.svg', label: 'Kenya' },
  { code: 'IN', icon: 'assets/icons/flags/india.svg', label: 'India' },
  { code: 'PK', icon: 'assets/icons/flags/pakistan.svg', label: 'Pakistan' },
];


export const JORDAN_CODE = 'JO';

export const ARAB_COUNTRIES = [
  'KW', 'QA', 'SA', 'AE', 'OM', 'BH', 'EG'
];


export const governate = [
  { label: 'Ajloun' },
  { label: 'Amman' },
  { label: 'Aqaba' },
  { label: 'Irbid' },
  { label: 'Jerash' },
];

export const licenseIssuer = [
  { label: 'Aqaba City' },
  { label: 'Alqwarrah Municipality' },
  { label: 'Hod Aldisah Municipality' },
  { label: 'Katr w Rahmah Municipality' },
  { label: 'Qrayqra w Vinan Municipality' },
];

export const businessSector = [
  { label: 'A non-profit company' },
  { label: 'Accounting, bookkeeping, auditing and tax consulting activities' },
  { label: 'Activities of natural reserves and parks' },
  { label: 'Activities of news agencies' },
  { label: 'Activities of professional organizations' },
];

export const relationType = [
  { label: 'Agent' },
  { label: 'Business entity' },
  { label: 'Merchant' },
  { label: 'Government' }
];

export const merchantCategory = [
  { label: 'Commerce' },
  { label: 'Communications and information' },
  { label: 'E-commerce' },
  { label: 'Education' },
  { label: 'Other' },
];

export const businessSize = [
  { label: 'Small corporate' },
  { label: 'Medium corporate' },
  { label: 'Big corporate' }
];

export const numberOfEmployees = [
  { label: '1-4' },
  { label: '5-9' },
  { label: '10-24' },
  { label: '25-49' },
  { label: '50-99' },
  { label: '100-499' },
  { label: '500-999' },
  { label: '1000+' }
];

export const companyCapital = [
  { label: '1 JOD – 1,000 JOD' },
  { label: '1,001 JOD – 5,000 JOD' },
  { label: '5,001 JOD – 10,000 JOD' },
  { label: '10,001 JOD – 50,000 JOD' },
  { label: '50,001 JOD – 990,000 JOD' },
  { label: 'More than 990,000 JOD' }
];

export const annualRevenues = [
  { label: '1 JOD – 10,000 JOD' },
  { label: '10,001 JOD – 20,000 JOD' },
  { label: '20,001 JOD – 40,000 JOD' },
  { label: '40,001 JOD – 60,000 JOD' },
  { label: 'More than 60,000 JOD' }
];

export const months = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 },
]